import React, { useEffect } from "react";
import { Outlet } from 'react-router-dom';

import { useAuth0 } from "@auth0/auth0-react";

import { CircularProgress, Box } from '@mui/material';

function RequiredAuth() {
  const { isLoading, loginWithRedirect, isAuthenticated } = useAuth0();

  useEffect(() => {
    if (!isAuthenticated) {
      const originalUri = window.location.pathname + window.location.search;
      loginWithRedirect(
        { appState: { returnTo: originalUri } }
      );
    }
  }, [isAuthenticated, loginWithRedirect]);

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <img height="80px" src="/ceph_logo.png" alt="cep-logo" />
        <CircularProgress sx={{ color: '#0077C8', ml: 4 }} />
      </Box>
    );
  }

  return (<Outlet />);
}

export default RequiredAuth;
